import React from "react";
import ProcessFlowContent from "../function-components/ProcessFlowContent";

function ProcessFlow() {
  return (
    <>
      <ProcessFlowContent />
    </>
  );
}

export default ProcessFlow;
